import { ca } from '@cian/analytics';

export const trackClientInfoPromoShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Show',
    label: 'SubsClientInfoUpgradeLevel',
  });
};
